import { createContext, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AppService from 'services/app.service';
import FbService from 'FB';
import { removeAppAuthToken, removeStoredAuthToken, removeTokenCode, removeStoredUser } from 'utils/auth';
import { useApp } from './AppContext';

const AuthContext = createContext(null);
AuthContext.displayName = 'AuthContext';

export const AuthProvider = ({ children }) => {
  const app = useApp();

  const signin = async tokenCode => {
    return await AppService.appUserLogin(tokenCode);
  };

  const signout = () => {
    // TODO: rest app state need to run after facebook logout.
    // current app state don't have user token after reloagin from storage data.
    // require fix the flow on non POC product.
    removeStoredUser();
    removeStoredAuthToken();
    removeAppAuthToken();
    removeTokenCode();
    app.resetAppState(); // Resets the global state via AppContext
    FbService.logout();
  };

  // The value provided to the context consumers
  const auth = {
    user: app.state.user,
    signin,
    signout,
    update: app.setUserData,
  };

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

// 3. Create a custom hook for easy consumption
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    console.error('useAuth must be used within an AuthProvider');
    return;
  }
  return context;
};

export const AuthGuard = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
